export const WASTE = 'waste';
export const INCOME = 'income';
export const TRANSFER = 'transfer';
export const transactionTypes = [WASTE, INCOME, TRANSFER];
